"use client";

import ApplicationListSkeleton from "@/components/molecules/ApplicationsList/applicationsListSkeleton";

const CategoryLoading = () => {
  return <ApplicationListSkeleton />;
};

export default CategoryLoading;
